import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const AddChildToFamilyMutation = graphql.persisted(
  "AddChildToFamily",
  graphql(`
    mutation AddChildToFamily(
      $familyId: ID!
      $firstName: String!
      $lastName: String!
      $dateOfBirth: ISO8601Date
      $gender: GenderEnum!
    ) {
      addChildToFamily(input: {
        familyId: $familyId
        firstName: $firstName
        lastName: $lastName
        dateOfBirth: $dateOfBirth
        gender: $gender
      }) {
        family {
          id
          children {
            person { id firstName lastName gender dateOfBirth }
          }
        }
        person { id firstName lastName }
        userErrors { message path }
      }
    }
  `)
);

export { AddChildToFamilyMutation };

export function useAddChildToFamily() {
  return useMutation(AddChildToFamilyMutation);
}
